BaseManager = require 'BaseManager'
loglevel = require 'loglevel'

###############################################

class NetworkManager extends BaseManager

  name: 'NetworkManager'

  # -------------------------------------------

  getJSON: (path, callback) ->
    path = path + "?v=" + window.__version
    request = new XMLHttpRequest()
    request.open('GET', path, true)
    request.timeout = 120000

    request.onload = ->
      if request.status >= 200 and request.status < 400
        # Success!
        data = JSON.parse(request.responseText)
      else
        callback null, 'FAIL', request.status
        return
      callback data, null, request.status

    request.onerror = (err) ->
      callback null, err, request.status

    request.ontimeout = ->

      callback null, 'timeout', request.status

    request.send()

  # -------------------------------------------

module.exports = NetworkManager.getInstance()



// WEBPACK FOOTER //
// ./coffee/manager/network-manager.coffee